"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var Eye = function Eye(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 18 12"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    opacity: ".8"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.21 3.118A1.495 1.495 0 0 1 6.117 5.21 2.993 2.993 0 1 0 9 3a2.978 2.978 0 0 0-.79.118zM4.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0zm13.391-.456C16.197 2.237 12.841 0 9 0 5.158 0 1.802 2.239.109 5.544a1.011 1.011 0 0 0 0 .912C1.803 9.763 5.159 12 9 12c3.842 0 7.198-2.239 8.891-5.544a1.011 1.011 0 0 0 0-.912z"
  })))));
};
var _default = exports.default = Eye;